import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";
import { adminService } from '@/api/services/adminService';

interface DealerCategoryState {
  dealerCategories: { id: string; dealerCategory: string }[]; 
  loading: boolean;
  error: string | null;
}

const initialState: DealerCategoryState = {
  dealerCategories: [],
  loading: false,
  error: null,
};

export const getDealerCategories = createAsyncThunk(
  'dealerCategory/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const response = await adminService.fetchDealers();
      console.log("API Response:", response);
      if (response.success) {
        return response.data || []; // Ensure it's an array
      } else {
        return rejectWithValue(response.errors);
      }
    } catch (error) {
      console.error("API Error:", error);
      return rejectWithValue(error);
    }
  }
);


const dealerCategorySlice = createSlice({
  name: 'dealerCategory',
  initialState,
  reducers: {
    resetDealerCategoryState: () => initialState,

  },
  extraReducers: (builder) => {
    builder
      .addCase(getDealerCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDealerCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.dealerCategories = Array.isArray(action.payload) ? action.payload : [];
      })            
      .addCase(getDealerCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});
export const { resetDealerCategoryState } = dealerCategorySlice.actions;

export default dealerCategorySlice.reducer;